/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimpleViewAcademicUserDTO,
    SimpleViewAcademicUserDTOFromJSON,
    SimpleViewAcademicUserDTOFromJSONTyped,
    SimpleViewAcademicUserDTOToJSON,
} from './SimpleViewAcademicUserDTO';

/**
 * 
 * @export
 * @interface SimpleViewAcademicUserDTOPagedResponse
 */
export interface SimpleViewAcademicUserDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SimpleViewAcademicUserDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleViewAcademicUserDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleViewAcademicUserDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SimpleViewAcademicUserDTO>}
     * @memberof SimpleViewAcademicUserDTOPagedResponse
     */
    data?: Array<SimpleViewAcademicUserDTO> | null;
}

export function SimpleViewAcademicUserDTOPagedResponseFromJSON(json: any): SimpleViewAcademicUserDTOPagedResponse {
    return SimpleViewAcademicUserDTOPagedResponseFromJSONTyped(json, false);
}

export function SimpleViewAcademicUserDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleViewAcademicUserDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(SimpleViewAcademicUserDTOFromJSON)),
    };
}

export function SimpleViewAcademicUserDTOPagedResponseToJSON(value?: SimpleViewAcademicUserDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(SimpleViewAcademicUserDTOToJSON)),
    };
}

